import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export default function Dashboard() {
  const [totalMembers, setTotalMembers] = useState(0);
  const [totalSavingAC, setTotalSavingAC] = useState(0);
  const [dueBalance, setDueBalance] = useState(0);
  const [advanceBalance, setAdvanceBalance] = useState(0);
  const [todayCash, setTodayCash] = useState(0);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    /* ================= MEMBERS ================= */
    const membersSnap = await getDocs(collection(db, "members"));
    setTotalMembers(membersSnap.size);

    // ✅ FIX: Total Saving A/C = Total Members
    setTotalSavingAC(membersSnap.size);

    /* ================= LEDGER ================= */
    const ledgerSnap = await getDocs(collection(db, "savingLedger"));

    const calc = {};
    let todayCashCalc = 0;
    const todayStr = new Date().toDateString();

    ledgerSnap.forEach(doc => {
      const d = doc.data();
      if (!d.memberId) return;

      if (!calc[d.memberId]) {
        calc[d.memberId] = { credit: 0, debit: 0 };
      }

      // CREDIT / DEBIT
      if (d.type === "CREDIT") calc[d.memberId].credit += Number(d.amount || 0);
      if (d.type === "DEBIT") calc[d.memberId].debit += Number(d.amount || 0);

      // DEPOSIT / WITHDRAWAL
      if (d.deposit) {
        calc[d.memberId].credit += Number(d.deposit || 0);
        if (d.createdAt?.toDate().toDateString() === todayStr) {
          todayCashCalc += Number(d.deposit || 0);
        }
      }

      if (d.withdrawal) {
        calc[d.memberId].debit += Number(d.withdrawal || 0);
        if (d.createdAt?.toDate().toDateString() === todayStr) {
          todayCashCalc -= Number(d.withdrawal || 0);
        }
      }
    });

    /* ================= TOTAL DUE / ADVANCE ================= */
    let totalAdvance = 0;
    let totalDue = 0;

    Object.values(calc).forEach(m => {
      const balance = m.credit - m.debit;
      if (balance > 0) totalAdvance += balance;
      if (balance < 0) totalDue += Math.abs(balance);
    });

    setAdvanceBalance(totalAdvance);
    setDueBalance(totalDue);
    setTodayCash(todayCashCalc);

    console.log("✅ DASHBOARD FINAL OK", {
      members: membersSnap.size,
      savingAC: membersSnap.size,
      totalAdvance,
      totalDue,
      todayCashCalc,
    });
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-4">Dashboard</h4>

      <div className="row g-3">
        <div className="col-md-3">
          <div className="card text-white bg-primary">
            <div className="card-body">
              <h6>Total Members</h6>
              <h3>{totalMembers}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-white bg-success">
            <div className="card-body">
              <h6>Total Saving A/C</h6>
              <h3>{totalSavingAC}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-white bg-danger">
            <div className="card-body">
              <h6>Total Due Balance</h6>
              <h3>₹ {dueBalance}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-white bg-info">
            <div className="card-body">
              <h6>Total Advance Balance</h6>
              <h3>₹ {advanceBalance}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4 mt-3">
          <div className="card text-white bg-warning">
            <div className="card-body">
              <h6>Today Cash In Hand</h6>
              <h3>₹ {todayCash}</h3>
              <small>{new Date().toLocaleDateString()}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}